<template>
<div class="">

    <div class="container">
        <div class="row">
            <div class="col-md-3 search__wrapper">
                <div class="search-wrapper">
                    <form>
                        <div class="grey-text">
                          <!--  <div class="row">
                              <div class="col-12">
                                  <mdb-select class="input__change" :key="componentKey" search :searchPlaceholder="$t('Suche.Suche')" :resultText="$t('Suche.KeineErgebnisse')" ref="ort" v-model="listOrte" @change="changeListOrte($event)" :label="$t('Suche.Stadtteil')" placeholder="Auswählen"></mdb-select>
                                  <mdb-input label="Stadtteil" type="text" v-model="Search.stadtteil" />
                                </div>
                            </div>
                             -->
                            <div class="row">
                                <div class="col-12">
                                        <mdb-select class="input__change" :key="componentKey" v-model="arten" @change="changeZimmerart($event)" :label="$t('Suche.Wohnungsart')" ref="art" :placeholder="$t('Global.Auswahlen')" ></mdb-select>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="search__label-headline">
                                        <h3 class="text-left">{{$t("Suche.Verfuegbarkeit")}}</h3>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <!-- <mdb-input label="Frei ab" type="text" v-model="Search.freiab" /> -->
                                    <mdb-date-picker v-model="Search.freiab" :option="option" :label="$t('Suche.Datumab')" />
                                </div>
                                <div class="col-6">
                                    <!-- <mdb-input label="Frei bis" type="text" v-model="Search.freibis" />
                                    <mdb-date-picker v-model="Search.freibis" :option="option" :label="$t('Suche.Datumbis')" />-->
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="search__label-headline">
                                        <h3 class="text-left">{{$t("Suche.Preis")}}</h3>
                                    </div>
                                </div>

                                <div class="col-6">
                                    <mdb-input :label="$t('Suche.Ab')" type="text" class="mt-1" v-model="Search.preisab" />
                                </div>
                                <div class="col-6">
                                    <mdb-input :label="$t('Suche.Bis')" type="text" class="mt-1" v-model="Search.preisbis" />
                                </div>
                            </div>
                            <div class="row mt-4 mb-4 mb-lg-0">
                                <div class="col-12">
                                    <button type="button" class="btn btn-outline-danger waves-effect" v-on:click="resetFilter()">{{$t("Suche.Reset")}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="col-md-8 offset-md-1 col-12 search-content">
                <div class="">
                    <div class="row">
                        <div class="col-12">
                             <Angebot :Angebote="SearchAngebote" :user="User"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        

    </div>
</div>
    
</template>
<script>
    import Angebot from "@/components/angebot/mieter/Angebote";
    import AngebotService from "@/services/AngebotService";
    import { mdbInput, mdbBtn, mdbSelect,mdbDatePicker } from 'mdbvue';
    import SettingService from '@/services/SettingsService';
    //import Modal from "./Show";
    import settings from '@/components/Settings.json';
    import format from 'date-fns/format';
    import compareAsc from 'date-fns/compare_asc';
    export default {
        name: "Search",
        components: {
            Angebot,
            mdbInput,
            mdbBtn,
            mdbSelect,
            mdbDatePicker
            //Modal

        },
        data(){
            return{
                User: Object,
                users: "",
                timer: true,
                resetTimer: false,
                Angebote: [],
                SearchAngebote: [],
                arten: [],
                listOrte: [],
                componentKey: 0,
                Texte: "",
                option: {
                    format: 'DD.MM.YYYY',
                    week: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
                    month: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    buttons: {
                        ok: 'Ok',
                        cancel: 'Abbrechen',
                        today: 'Heute',
                        clear: 'Löschen'
                    }
                },
                Search: {
                    zimmerart: "",
                    stadtteil: "",
                    freiab: "",
                    preisab: "",
                    preisvon: ""
                }
            }
        },
        methods:{
            changeListOrte(event) {
                if(event){
                    let orteCount = this.listOrte.length;
                    for (let i = 0; i < orteCount; i++) {
                        if(this.listOrte[i].value == event){
                            this.Search.stadtteil = this.listOrte[i].text;
                            this.$set(this.Search,'stadtteil', this.listOrte[i].text);
                        }
                    }
                }
            },
            resetFilter(){
                //this.$refs.ort.reset();
                this.$refs.art.reset();
                this.Search.zimmerart = "";
                this.Search.stadtteil = "";
                this.Search.freiab = "";
                this.Search.preisab = "";
                this.Search.preisbis = "";
                this.componentKey += 1;
            },
            showModal(id){
                this.$refs.modal.showIt(id)
            },
            changeZimmerart(event) {

                this.Search.zimmerart = event;
                this.$set(this.Search,'zimmerart', event);
                //this.$watch();
            },
        },
        created() {
            let user = this.$store.getters.userObject;
            this.User = user;
            this.Texte = this.$locales.Texte;
            AngebotService.getAngebote()
                .then(response => {
                    let angebotData = response.data;
                    this.Angebote = angebotData;
                    this.SearchAngebote = angebotData; // <--- set the events when returned

                })
                .catch(error => {
                    console.log("There was an error:", error.response);
                });
        },
        mounted: function(){
            this.listOrte = this.$store.getters.places;
            this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
        },
        watch: {
            Search:{
                handler: function (val, oldVal) {
                    let parameters = [];
                    let parameterSize  = Object.keys(this.Search).length;

                    for(let prop in this.Search) {
                        if(this.Search[prop] != "" && this.Search[prop] != null){
                            let item = [prop, this.Search[prop]];
                            parameters.push(item)
                        }
                    }
                    let _this = this;
                    function searchForAngebot(Angebot){

                        if(parameters.length == 0){
                            return Angebot
                        }
                        for(let i = 0; i < parameters.length; i++) {
                            let filterItemName = parameters[i][0];
                            let filterItemValue = parameters[i][1];

                            let miete = 0;
                            let nebenkosten = 0;

                            if(Angebot["miete"]){
                              miete = parseInt(Angebot["miete"], 10);
                            }

                            if(Angebot["nebenkosten"]){
                              nebenkosten = parseInt(Angebot["nebenkosten"], 10);
                            }

                            let gesamtKosten = miete + nebenkosten;


                            if(filterItemName == "preisab"){
                                if(!Angebot["miete"] || Angebot["miete"] == 0){
                                    return false
                                }
                                if(gesamtKosten <= parseInt(filterItemValue,10)){
                                    return false;
                                }

                            } else if(filterItemName == "preisbis"){

                                if(!Angebot["miete"] || Angebot["miete"] == 0){
                                    return false
                                }
                                if(gesamtKosten > parseInt(filterItemValue,10)){
                                    return false;
                                }

                            } else if(filterItemName == "freiab"){

                                let searchDate = filterItemValue;
                                let angebotDate = Angebot[filterItemName];


                                if(angebotDate == '000-00-00 00:00:00'){
                                  continue
                                }

                              let splittedFormat = searchDate.split(".")
                              let splittedFormat1 = angebotDate.split(".")




                               let d1, d2;
                               d1 = new Date(splittedFormat[2]+'-'+splittedFormat[1]+"-"+splittedFormat[0])
                               if(splittedFormat1.length > 1){
                                  d2 = new Date(splittedFormat1[2]+'-'+splittedFormat1[1]+"-"+splittedFormat1[0])
                               } else {
                                  d2 = new Date(angebotDate)
                               }




                              if(d1.getTime() < d2.getTime()){
                                return false
                              }


                              if(Angebot['freibis']){
                                let angebotEndDate = Angebot['freibis'];
                                let splittedFormat2 = angebotEndDate.split(".")
                                if(splittedFormat2.length > 1){
                                  angebotEndDate = new Date(splittedFormat2[2]+'-'+splittedFormat2[1]+"-"+splittedFormat2[0])
                                } else {
                                  angebotEndDate = new Date(Angebot['freibis'])
                                }
                                if(d1.getTime() > angebotEndDate.getTime()){
                                  return false
                                }
                              }

                              continue;

                            } else if(filterItemName == "zimmerart") {

                               if(!Angebot["zimmerart"]){
                                    return false
                               }
                              if(Angebot["zimmerart"].indexOf(filterItemValue) != -1){
                                continue;
                              } else {
                                return false;
                              }


                            } else if(filterItemName == "stadtteil"){
                                    let isValid1 = true;
                                    let isValid2 = true;
                                    if(Angebot["stadtteil"] ){
                                        if(Angebot["stadtteil"].indexOf(filterItemValue) == -1){
                                            isValid1 = false;
                                        }
                                    }
                                    if(Angebot["ort"] ){
                                        if(Angebot["ort"].indexOf(filterItemValue) == -1){
                                            isValid2 = false;
                                        }
                                    }
                                    if(!isValid1 && !isValid2){
                                        return false
                                    }

                            } else {
                                continue;
                            }
                        }
                        return Angebot
                    }


                    let tempAngebote = this.Angebote;
                    let filteredAngebote = tempAngebote.filter(searchForAngebot);
                    this.SearchAngebote = filteredAngebote;
                    
                    
                },
                deep: true,
            },
        }
    }
</script>